import { render, staticRenderFns } from "./ConfigLabelButton.vue?vue&type=template&id=14727119&"
import script from "./ConfigLabelButton.vue?vue&type=script&lang=js&"
export * from "./ConfigLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports